module.exports = __webpack_public_path__ + "img/1.03b3cf27.png";